'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FriendbuyWidgetContainer = exports.mapStateToProps = undefined;

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _decorator = require('helpers/decorator');

var _deep = require('helpers/deep');

var _FriendbuyWidget = require('./FriendbuyWidget');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, props) {
  var profile = _bound.userProfile.data(state) || {};

  return {
    userId: profile.id,
    countryCode: (0, _deep.deepExtract)('msa.country_code', profile, 'USA'),
    email: profile.email,
    widgetCode: props.widgetCode || (0, _deep.deepExtract)('friendbuy_info.widget_code', profile, '')
  };
};

var FriendbuyWidgetContainer = exports.FriendbuyWidgetContainer = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), _reactIntl.injectIntl, (0, _decorator.withName)('FriendbuyWidgetContainer'))(_FriendbuyWidget.FriendbuyWidget);